module.exports = __webpack_public_path__ + "static/media/student20.4f569080.png";